import { BaseModel } from "./BaseModel";
import { AxiosResponse } from "axios";
import { Result } from "../Contracts/IMdels";

export interface ApiResultTyped<T> extends Result {
  data: T;
}

export interface IManagementVehicleStat {
  row: number;
  vehicleTypeId: number | null;
  name: string;
  count: number;
  totalAmount: number;
  totalAmountToman: number;
  percentage: number;
}

export interface IManagementTariffStat {
  row: number;
  tariffId: number | null;
  avarezCode: string;
  title: string;
  vehicleTypeName: string;
  serviceTypeName: string;
  count: number;
  totalAmount: number;
  totalAmountToman: number;
  percentage: number;
}

export interface IManagementYearlyStat {
  year: number;
  count: number;
  paidCount: number;
  totalAmount: number;
  totalAmountToman: number;
  percentage: number;
}

export interface IManagementMonthlyStat {
  monthNumber: number;
  monthName: string;
  year: number;
  count: number;
  totalAmount: number;
  totalAmountToman: number;
}

export interface IManagementBillRow {
  id: number;
  billNumber: string;
  code: number;
  year: number;
  motaghazi: string;
  nationalCode: string;
  plateNumber: string;
  taxiCode: string;
  totalAmount: number;
  totalAmountToman: number;
  isPaid: boolean;
  issueDateShamsi: string;
  paidDateShamsi: string;
  itemsCount: number;
  mainTariffTitle: string;
}

export interface IManagementSummary {
  organName: string;
  title: string;
  reportDateShamsi: string;
  reportNumber: string;
  fromDateShamsi?: string;
  toDateShamsi?: string;
  selectedPeriodTitle?: string;
  totalBills: number;
  paidBillsCount: number;
  unpaidBillsCount: number;
  collectionRate: number;
  totalAmount: number;
  totalAmountToman: number;
  paidAmount: number;
  paidAmountToman: number;
  unpaidAmount: number;
  unpaidAmountToman: number;
  averageBillAmount: number;
  totalBillItems: number;
  activeVehiclesCount: number;
  bankInfo: {
    bankName: string;
    accountNumber: string;
    managerName: string;
    phoneNumber: string;
    address: string;
    description: string;
  };
  vehicleTypeStats: IManagementVehicleStat[];
  tariffStats: IManagementTariffStat[];
  yearlyStats: IManagementYearlyStat[];
  monthlyStats: IManagementMonthlyStat[];
  recentBills: IManagementBillRow[];
}

export class ManagementReportModel extends BaseModel {
  protected RouteName: string = "ManagementReport";
  protected AuthState: boolean = false; // Allow easy access for management dashboard

  public async getSummary(
    fromDate?: string,
    toDate?: string,
    year?: string | number,
    search?: string
  ): Promise<AxiosResponse<ApiResultTyped<IManagementSummary>>> {
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (year) params.append("year", year.toString());
      if (search) params.append("search", search.toString());
      const query = params.toString() ? `?${params.toString()}` : "";

      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/summary${query}`);
    } catch (e: any) {
      throw e?.response?.data?.message || "خطا در دریافت خلاصه گزارش مدیریتی";
    }
  }

  public async getBills(
    fromDate?: string,
    toDate?: string,
    year?: string | number,
    search?: string,
    page: number = 1,
    pageSize: number = 50
  ): Promise<AxiosResponse<ApiResultTyped<IManagementBillRow[]>>> {
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (year) params.append("year", year.toString());
      if (search) params.append("search", search.toString());
      params.append("page", page.toString());
      params.append("pageSize", pageSize.toString());

      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/bills?${params.toString()}`);
    } catch (e: any) {
      throw e?.response?.data?.message || "خطا در دریافت لیست قبوض مدیریتی";
    }
  }

  public getStimulsoftPrintUrl(
    fromDate?: string,
    toDate?: string,
    year?: string | number,
    search?: string
  ): string {
    try {
      const url = new URL(this.baseApi.baseUrl);
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (year) params.append("year", year.toString());
      if (search) params.append("search", search.toString());
      const query = params.toString() ? `?${params.toString()}` : "";

      return `${url.protocol}//${url.host}/webroutes/ManagementReport/print${query}`;
    } catch {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (year) params.append("year", year.toString());
      const q = params.toString() ? `?${params.toString()}` : "";
      return `/webroutes/ManagementReport/print${q}`;
    }
  }
}
